import getCookieValue from '../hooks/getCookieValue';

class dataDogHandler {
    constructor() {
        this.datadogRum = window.DD_RUM;
    }

    createView(view) {
        if (!this.isReady()) {
            return;
        }
        this.datadogRum.startView(view, {
            name: view
            // path: '/new-section'
        });
    }

    // createViewSession() { }

    createUserSession(user) {
        if (!this.isReady()) {
            return;
        }
        this.datadogRum.setUser({
            id: getCookieValue('livechat_visitor_id'),
            name: `chat-user${env.BUILD_HASH}`,
            email: `${env.BUILD_HASH}@blazeo.com`,
            plan: 'premium'
        });
    }

    addError(error) {
        if (!this.isReady()) {
            return;
        }
        this.datadogRum.addError(error.message);
    }

    createAction(action) {
        if (!this.isReady()) {
            return;
        }
        this.datadogRum.addAction(
            action.name,
            {
                key: action.key,
                data: action.data
            }
            // ,
            //     {
            //     buttonColor: 'blue', // Add custom attributes for context
            //     pageSection: 'signup_form'
            // }
        );
    }

    isReady() {
        return this.datadogRum && typeof this.datadogRum.init === 'function';
    }
}
export default dataDogHandler;
